module.exports = __webpack_public_path__ + "img/computer-happy.a57565a0.svg";